var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"t-card-list",class:{'border-top': _vm.borderTop, 'border-bottom': _vm.borderBottom}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }